export class MarqueeSelect {
    constructor(config) {
        this.wrapper = config.wrapper;
        this.getNodes = config.getNodes;
        this.onSelectionChange = config.onSelectionChange;
        this.onSelectionComplete = config.onSelectionComplete;
        this.isSelecting = false;
        this.marqueeEl = null;
        this.startX = 0;
        this.startY = 0;
        this.selectedNodeIds = new Set();
        
        // 1. Bind methods so they can be properly added AND removed
        this._boundHandleMouseMove = this._handleMouseMove.bind(this);
        this._boundHandleMouseUp = this._handleMouseUp.bind(this);

        this._injectCSS();
        this.init();
    }

    _injectCSS() {
        if (document.getElementById('marquee-styles')) return;
        const style = document.createElement('style');
        style.id = 'marquee-styles';
        style.innerHTML = `
            .marquee-rect { position: absolute; border: 2px solid #3b82f6; background: rgba(59, 130, 246, 0.1); z-index: 99999; pointer-events: none; border-radius: 4px; }
            .sb-node.is-selected { outline: 4px solid #3b82f6 !important; outline-offset: 4px; }
        `;
        document.head.appendChild(style);
    }

    init() {
        // 2. Use the bound methods
        window.addEventListener('mousemove', this._boundHandleMouseMove);
        window.addEventListener('mouseup', this._boundHandleMouseUp);
    }

    // 3. Add the destroy method to handle cleanup and prevent memory leaks
    destroy() {
        window.removeEventListener('mousemove', this._boundHandleMouseMove);
        window.removeEventListener('mouseup', this._boundHandleMouseUp);
        
        if (this.marqueeEl) {
            this.marqueeEl.remove();
            this.marqueeEl = null;
        }
    }

    startSelection(e) {
        this.isSelecting = true;
        
        // 1. Clear the PREVIOUS selection when starting a new selection drag/click
        this.selectedNodeIds.clear();
        this.onSelectionChange(this.selectedNodeIds);

        const rect = this.wrapper.getBoundingClientRect();
        this.startX = e.clientX - rect.left;
        this.startY = e.clientY - rect.top;

        this.marqueeEl = document.createElement('div');
        this.marqueeEl.className = 'marquee-rect';
        this.marqueeEl.style.left = `${this.startX}px`;
        this.marqueeEl.style.top = `${this.startY}px`;
        this.wrapper.appendChild(this.marqueeEl);
    }

    _handleMouseMove(e) {
        if (!this.isSelecting) return;
        const rect = this.wrapper.getBoundingClientRect();
        const curX = e.clientX - rect.left;
        const curY = e.clientY - rect.top;

        const left = Math.min(this.startX, curX);
        const top = Math.min(this.startY, curY);
        const width = Math.abs(curX - this.startX);
        const height = Math.abs(curY - this.startY);

        this.marqueeEl.style.left = `${left}px`;
        this.marqueeEl.style.top = `${top}px`;
        this.marqueeEl.style.width = `${width}px`;
        this.marqueeEl.style.height = `${height}px`;

        this._checkIntersections();
    }

    _handleMouseUp() {
        if (!this.isSelecting) return;
        this.isSelecting = false;
        
        const selectedNodes = this.getNodes().filter(n => this.selectedNodeIds.has(n.id));
        if (selectedNodes.length > 0 && this.onSelectionComplete) {
            this.onSelectionComplete(selectedNodes);
        }

        if (this.marqueeEl) {
            this.marqueeEl.remove();
            this.marqueeEl = null; 
        }
        
        // BUG FIX: Removed this.selectedNodeIds.clear() from here!
        // The selection should remain active after the mouse is released.
    }

    _checkIntersections() {
        const mRect = this.marqueeEl.getBoundingClientRect();
        const currentSelected = new Set();
        this.getNodes().forEach(node => {
            const el = this.wrapper.querySelector(`.sb-node[data-id="${node.id}"]`);
            if (!el) return;
            const r = el.getBoundingClientRect();
            if (!(r.left > mRect.right || r.right < mRect.left || r.top > mRect.bottom || r.bottom < mRect.top)) {
                currentSelected.add(node.id);
            }
        });
        this.selectedNodeIds = currentSelected;
        this.onSelectionChange(this.selectedNodeIds);
    }
}